import { Injectable } from "@angular/core";
import { Action } from "@ngrx/store";
import { ActionWithPayload } from "@obg/ngrx-utils";
import { AppError } from "@obg/ngx.core";

import { ProductLink } from "./product-link.model";

const ACTION_PREFIX = "[Product Link]";
export const PRODUCT_LINK_ACTION_TYPE = {
	get: `${ACTION_PREFIX} Get Content`,
	getSuccess: `${ACTION_PREFIX} Fetch Content Success`,
	getFail: `${ACTION_PREFIX} Fetch Content Fail`,
};

@Injectable({
	providedIn: "root",
})
export class ProductLinkAction {
	get(): Action {
		return {
			type: PRODUCT_LINK_ACTION_TYPE.get,
		};
	}

	getSuccess(payload: ProductLink[]): ActionWithPayload {
		return {
			type: PRODUCT_LINK_ACTION_TYPE.getSuccess,
			payload,
		};
	}

	getFail(error: AppError): ActionWithPayload {
		return {
			type: PRODUCT_LINK_ACTION_TYPE.getFail,
			payload: error,
		};
	}
}
